module.exports = __webpack_public_path__ + "img/fence-original.67db8e29.png";